<template>
  <div>
    <template v-if="egress_profile_matter_id">
      <MatterProgram
        :egress_profile_matter_id="egress_profile_matter_id"
        :allows_crud="allows_crud"
        :can_delete="can_delete"
        :can_update="can_update"
        class="px-1"
      ></MatterProgram>
    </template>
    <template v-else> {{ $t("reusable.common.errorOccurred") }} </template>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import matterLanguageMixin from "@/mixins/matterLanguageMixin";
export default {
  name: "MatterProgramView",
  mixins: [matterLanguageMixin],
  components: {
    MatterProgram: () => import("./MatterProgram"),
  },
  data() {
    return {
      egress_profile_matter_id: Number(this.$route.params.matter_id),
      to_print: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      egressProfiles: names.EGRESS_PROFILES,
      careers: names.CAREERS,
      egress_profiles_matters: names.EGRESS_PROFILES_MATTERS,
      matters: names.MATTERS,
    }),
    egressProfile() {
      if (!this.matter) return [];
      return this.egressProfiles.find(
        (x) => x.id == this.matter.egress_profile
      );
    },
    career() {
      if (!this.egressProfile) return null;
      return this.careers.find((x) => x.id == this.egressProfile.career);
    },
    isUdalba() {
      return this.institution && this.institution.internal_use_id == "udalba.cl";
    },
    allows_crud() {
      // (!this.matter.is_closed || !this.oldMatter.is_closed) &&
      if (
        this.career &&
        this.egressProfile &&
        !this.egressProfile.is_closed &&
        this.matter &&
        this.oldMatter &&
        (this.can_update || this.can_delete)
      ) {
        const has_permission = this.$hasPermissions("teaching.change_matter");
        if (has_permission) {
          this.$store.commit(names.MUTATE_VISIBILITY_CRUD, true);
          return has_permission;
        } else {
          return false;
        }
      } else {
        this.$store.commit(names.MUTATE_VISIBILITY_CRUD, false);
        return false;
      }
    },
    can_update() {
      if (
        (this.user &&
          [
            "DIRECTIVOS ACADÉMICOS INSTITUCIONALES",
            "DIRECTIVOS ACADÉMICOS (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group))) ||
        this.user.is_superuser
      )
        return true;
      if (this.career && this.egressProfile && this.user) {
        const allowed_groups = [
          "DIRECTIVOS FACULTAD O ESCUELA",
          "DIRECTORES DE CARRERA",
          "DIRECTORES DE CARRERA (CAMPUS)",
        ];
        // Requerimiento UDALBA: ADMINISTRATIVOS INSTRUCCIONALES no edita el
        // programa de la asignatura; solo edita dentro de NewEvaluation
        // (accedido desde MatterProgramEvaluation).
        if (!this.isUdalba) allowed_groups.push("ADMINISTRATIVOS INSTRUCCIONALES");
        return (
          allowed_groups.some((group) =>
            this.user.group_names.includes(group)
          ) &&
          (this.$hasObjectPermission(
            "mesh.faculty",
            "change",
            this.career.faculty
          ) ||
            // this.$hasObjectPermission(
            //   "mesh.career",
            //   "change",
            //   this.career.id
            // ) ||
            this.$hasObjectPermission(
              "mesh.egressprofile",
              "change",
              this.egressProfile.id
            ))
        );
      }
      return false;
    },
    can_delete() {
      if (
        (this.user &&
          [
            "DIRECTIVOS ACADÉMICOS INSTITUCIONALES",
            "DIRECTIVOS ACADÉMICOS (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group))) ||
        this.user.is_superuser
      )
        return true;
      if (this.career && this.egressProfile && this.user) {
        // Requerimiento UDALBA: ADMINISTRATIVOS INSTRUCCIONALES (sin otro rol
        // directivo) no puede eliminar en el programa de la asignatura.
        if (
          this.isUdalba &&
          this.user.group_names.includes("ADMINISTRATIVOS INSTRUCCIONALES") &&
          ![
            "DIRECTIVOS FACULTAD O ESCUELA",
            "DIRECTORES DE CARRERA",
            "DIRECTORES DE CARRERA (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group))
        )
          return false;
        return (
          this.$hasObjectPermission(
            "mesh.faculty",
            "delete",
            this.career.faculty
          ) ||
          // this.$hasObjectPermission("mesh.career", "delete", this.career.id) ||
          this.$hasObjectPermission(
            "mesh.egressprofile",
            "delete",
            this.egressProfile.id
          )
        );
      }
      return false;
    },
    matter() {
      return this.egress_profiles_matters.find(
        (x) => x.id == this.egress_profile_matter_id
      );
    },
    oldMatter() {
      if (!this.matter) return null;
      return this.matters.find((x) => x.id == this.matter.matter);
    },
  },
  methods: {},
  created() {
    this.$store
      .dispatch(
        names.FETCH_EGRESS_PROFILE_MATTER,
        this.egress_profile_matter_id
      )
      .then((response) => {
        this.$store
          .dispatch(names.FETCH_EGRESS_PROFILE, response.egress_profile)
          .then((egress_profile) => {
            this.$store.dispatch(names.FETCH_CAREER, egress_profile.career);
            this.$store.dispatch(names.FETCH_EGRESS_PROFILES_MATTERS, {
              egress_profile_id: egress_profile.id,
            });
          });
      });
  },
  watch: {
    oldMatter: {
      immediate: true,
      handler(val) {
        if (!val) return;
        this.applyMatterLanguageById(val.default_language);
      },
    },
    matter: {
      immediate: true,
      handler(val) {
        if (!val) return;
        if (
          this.user &&
          this.user.student_card &&
          this.user.group_names.includes("ESTUDIANTES") &&
          this.user.student_card.egress_profile != val.egress_profile
        ) {
          this.$router.push({ name: "Page403" });
        }
        if (this.user && this.user.group_names.includes("PROFESORES")) {
          this.$restful
            .Get(`/mesh/fully_visible_professor_egress_profiles/`)
            .then((response) => {
              if (!response.includes(val.egress_profile)) {
                this.$router.push({ name: "Page403" });
              }
            });
        }
      },
    },
  },
  mounted() {},
};
</script>

<style scoped>
</style>